import React from 'react';
import DaumPostCode, {Address} from 'react-daum-postcode';
import {Container} from "react-bootstrap";
import * as device from 'react-device-detect';
import {PostModel, Window} from "../model/CustomModel";

declare var window: Window;
const PostCode = () => {
    const isAndroid = device.isAndroid;
    const isiOS = device.isIOS || device.isIOS13 || device.isIPhone13 || device.isIPad13;
    //alert(`${isAndroid},${isiOS},${window.ReactNativeWebView}`);
    const handleComplete = (data: Address) => {
        const param: PostModel = {post: data.zonecode, address: data.address, buildingName: data.buildingName};
        //console.log(`data=${JSON.stringify(data)}`);
        /*if (data.addressType === 'R') {
            if (isAndroid) {
                window.Android.setAddress(data.zonecode, data.roadAddress, data.buildingName);
            } else if (isiOS) {
                window.webkit.messageHandlers.setAddress.postMessage(data.zonecode, data.roadAddress, data.buildingName);
            } else {
                console.error('can not device type');
            }
        } else {
            if (isAndroid) {
                window.Android.setAddress(data.zonecode, data.jibunAddress, data.buildingName);
            } else if (isiOS) {
                window.webkit.messageHandlers.setAddress.postMessage(data.zonecode, data.jibunAddress, data.buildingName);
            } else {
                console.error('can not device type');
            }
        }*/
        const rvalue = JSON.stringify(param);

        if (isAndroid) {
            window.Android.setAddress(rvalue);
        } else if (isiOS) {
            window.webkit.messageHandlers.setAddress.postMessage(rvalue);
        } else {
            console.error('can not device type');
        }
        console.log(rvalue);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    }

    return (
        <div className="bloc l-bloc" id="bloc-0">
            <Container className="bloc-sm">
                <div className="row">
                    <div className="col-sm-12">
                        <DaumPostCode
                            onComplete={handleComplete}
                        />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default PostCode;
